import styled from "styled-components";

const Container = styled.div`
    background-color: var(--defaultBackground);
`;

export {
    Container
}